/**
 * Perf: avatares enviados pelos usuários chegam no tamanho original (já vimos
 * arquivos de 3 MB para um círculo de 28px). O endpoint de transformação do
 * storage não está habilitado neste projeto, então servimos as miniaturas por
 * um resizer de imagens público (wsrv.nl), que devolve WebP de poucos KB e
 * mantém cache na borda.
 */
const RESIZE_HOSTS = ["supabase.co/storage/v1", "image2url.com", "i.scdn.co"];

export function thumbUrl(url?: string | null, size = 96): string | undefined {
  if (!url) return url ?? undefined;
  if (url.startsWith("data:") || url.includes("wsrv.nl")) return url;
  if (!RESIZE_HOSTS.some((h) => url.includes(h))) return url;

  const px = Math.max(32, Math.min(1024, Math.round(size)));
  return `https://wsrv.nl/?url=${encodeURIComponent(url)}&w=${px}&h=${px}&fit=cover&q=72&output=webp`;
}

/** Versão para imagens não quadradas (capas de banner, prints, etc). */
export function widthThumbUrl(url?: string | null, width = 640): string | undefined {
  if (!url) return url ?? undefined;
  if (url.startsWith("data:") || url.includes("wsrv.nl")) return url;
  if (!RESIZE_HOSTS.some((h) => url.includes(h))) return url;

  const px = Math.max(64, Math.min(1600, Math.round(width)));
  return `https://wsrv.nl/?url=${encodeURIComponent(url)}&w=${px}&q=72&output=webp`;
}
